import Cropper from 'cropperjs';
import Choices from 'choices.js';
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';

import '../styles/forms.scss';

document.addEventListener('DOMContentLoaded', () => {
  // Initialise choices.js select inputs
  if (document.getElementsByClassName('js__choices').length !== 0) {
    const choices = new Choices('.js__choices', {
      removeItemButton: true,
    });
  }

  // Initialise choices.js text inputs
  const choicesJsFreeTextElements = document.querySelectorAll('.js__choices--free-text');

  for (let i = 0; i < choicesJsFreeTextElements.length; i += 1) {
    const choicesJsFreeTextElement = choicesJsFreeTextElements[i];

    (() => (new Choices(choicesJsFreeTextElement, {
      duplicateItemsAllowed: false,
      removeItemButton: true,
    })))();
  }

  $('#article_tag_list').select2({
    tags: true,
    tokenizer: function(input, s2, callback) {
      const term = input.term
      if (term.indexOf(',') < 0)
          return input;

      var parts = term.split(/,/);
      for (let i = 0; i < parts.length; i++) {
          let part = parts[i];
          part = part.trim();
          if (part !== "")
            callback({id:part,text:part});
      }
      return { term: parts.join(',') };
    }
  });

  // cropper
  window.coverImage = function coverImage() {
    if (document.getElementById('js__cover-image') !== null) {
      const coverImage = document.getElementById('cover-image-preview');
      const coverImageData = document.getElementById('js__cover-image').dataset;
      // const previewGig = document.querySelector('.gig_preview-image');
      // const imagePreviewGig = document.querySelector('.gig__cover-image');
      let previewReady = false;

      const xRatio = 1920;
      let yRatio = 765;

      if (coverImageData.name === 'event') {
        yRatio = 520;
      } else if (coverImageData.name === 'article') {
        yRatio = 960;
      }

      window.cropper = new Cropper(coverImage, {
        viewMode: 1,
        autoCropArea: 1,
        aspectRatio: xRatio / yRatio,
        guides: true,
        zoomable: false,
        rotatable: false,
        dragMode: 'none',
        data: {
          x: parseInt(coverImageData.x, 10),
          y: parseInt(coverImageData.y, 10),
          width: parseInt(coverImageData.width, 10),
          height: parseInt(coverImageData.height, 10),
        },
        checkCrossOrigin: false, // allow placeholders
        ready() {
          const loadingIndicator = document.getElementById('loading');
          const content = document.getElementsByClassName('content')[0];
          const mainForm = document.getElementsByClassName('main-form')[0];
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
          if (content) {
            content.style.overflowX = 'initial';
          }
          if (mainForm) {
            mainForm.style.visibility = 'visible';
          }
          Array.from(document.getElementsByClassName('datetime-select')).forEach((element) => {
            // eslint-disable-next-line no-param-reassign
            element.style.display = 'block';
          });
          previewReady = true;
        },
        // crop(event) {
        //   if (!previewReady) {
        //     return;
        //   }

        //   let data = event.detail;
        //   let cropper = window.cropper;
        //   const newImageUrl = window.cropper.url;
        //   let imageData = cropper.getImageData();
        //   let previewAspectRatio = data.width / data.height;

        //   if (imagePreviewGig) {
        //     imagePreviewGig.src = newImageUrl;
        //   }

        //   let previewImage = imagePreviewGig;
        //   let previewWidth = previewGig.offsetWidth;
        //   let imageScaledRatio = data.width / previewWidth;

        //   if (previewImage) {
        //     previewImage.style.width = imageData.naturalWidth / imageScaledRatio + 'px';
        //     previewImage.style.height = imageData.naturalHeight / imageScaledRatio + 'px';
        //     previewImage.style.marginLeft = -data.x / imageScaledRatio + 'px';
        //     previewImage.style.marginTop = -data.y / imageScaledRatio + 'px';
        //   }
        // },
      });

      coverImage.addEventListener('cropend', () => {
        const data = window.cropper.getData();
        ['x', 'y', 'width', 'height'].forEach((item) => {
          const element = document.getElementById(`${coverImageData.name}_cover_image_attributes_${item}`);
          if (element) {
            // Only set the value if the element exists
            element.value = data[item] >= 0 ? data[item] : 0;
          }
        });
      });
    }
  }
  
  const img = document.getElementById("cover-image-preview");
  if(img) {
    img.addEventListener("ready", function() {
      let inputX = document.querySelector(".cover_image_attributes_x");
      let inputY = document.querySelector(".cover_image_attributes_y");
      let inputWidth = document.querySelector(".cover_image_attributes_width");
      let inputHeight = document.querySelector(".cover_image_attributes_height");

      inputX.value = cropper.getData().x;
      inputY.value = cropper.getData().y;
      inputWidth.value = cropper.getData().width;
      inputHeight.value = cropper.getData().height;
    });
  }
});
